import PrimaryButton from './PrimaryButton';
import { motion } from 'framer-motion';

export default function TourSection() {
  return (
    <section className="bg-amber-50 py-16 text-center relative font-nunito overflow-hidden rounded-lg" style={{fontFamily: 'Nunito, sans-serif'}}>
      <div className="max-w-6xl mx-auto">
      <motion.h1 
        className="text-3xl md:text-4xl font-bold text-dblue mb-4 relative z-10"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        Apply for a tour and learn more!
      </motion.h1>
      
      <motion.p 
        className="text-gray-600 max-w-xl mx-auto mb-8 relative z-10"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
      >
        Interested in becoming part of our community? Your first step is to apply for a tour!
        Learn more about our step-by-step procedures below or apply now! 
      </motion.p>
      
      <motion.div 
        className="mb-8 relative z-10"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
      >
        <PrimaryButton text="Application Form" href="/application " />
      </motion.div>
      
      {/* Floating Seal */}
      <motion.img 
        src="/images/seal-removebg-preview.png" 
        className="absolute bottom-5 left-5 w-24 z-0" 
        alt="Seal"
        loading="lazy"
        decoding="async"
        animate={{ 
          y: [0, -10, 0],
          rotate: [0, 2, -2, 0]
        }}
        transition={{ 
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        whileHover={{ 
          scale: 1.1,
          rotate: [0, 5, -5, 0],
          transition: { duration: 0.5 }
        }}
      />
      
      {/* Floating Starfish */}
      <motion.img 
        src="/images/starfish.png" 
        className="absolute top-5 right-5 w-20 z-0" 
        alt="Starfish"
        loading="lazy"
        decoding="async"
        animate={{ 
          y: [0, -8, 0],
          rotate: [0, -3, 3, 0]
        }}
        transition={{ 
          duration: 3.5,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1
        }}
        whileHover={{ 
          scale: 1.15,
          rotate: 360,
          transition: { duration: 0.8 }
        }}
      />
      
      {/* Floating bubbles background */}
      <motion.div
        className="absolute top-1/4 left-1/4 w-4 h-4 bg-blue-200 rounded-full opacity-30"
        animate={{ 
          y: [0, -20, 0],
          x: [0, 10, 0],
          scale: [1, 1.2, 1]
        }}
        transition={{ 
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      <motion.div
        className="absolute top-3/4 right-1/3 w-3 h-3 bg-orange-200 rounded-full opacity-40"
        animate={{ 
          y: [0, -15, 0],
          x: [0, -8, 0],
          scale: [1, 1.3, 1]
        }}
        transition={{ 
          duration: 2.5,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.5
        }}
      />
      <motion.div
        className="absolute bottom-1/4 left-1/3 w-2 h-2 bg-yellow-200 rounded-full opacity-50"
        animate={{ 
          y: [0, -12, 0],
          x: [0, 5, 0],
          scale: [1, 1.4, 1]
        }}
        transition={{ 
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1.5
        }}
      />
      </div>
    </section>
  );
}